import React, { useState, useMemo } from 'react';
import BenefitCard from './BenefitCard';
import SkeletonLoader from './SkeletonLoader';
import ErrorMessage from './ErrorMessage';
import './BenefitGrid.css';

const BenefitGrid = ({ benefits, loading, error, retry, limit }) => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = useMemo(() => {
    const map = new Map();
    benefits.forEach((b) => {
      if (b.category) map.set(b.category.slug, b.category.name);
    });
    return Array.from(map.entries())
      .map(([slug, name]) => ({ slug, name }))
      .sort((a, b) => a.name.localeCompare(b.name, 'es'));
  }, [benefits]);

  if (loading) {
    return (
      <div className="benefit-grid-container">
        <SkeletonLoader variant="grid" count={limit || 8} />
      </div>
    );
  }

  if (error && benefits.length === 0) {
    return (
      <div className="benefit-grid-container">
        <ErrorMessage
          message="No se pudieron cargar los beneficios. Por favor, verifica tu conexión e intenta de nuevo."
          onRetry={retry}
        />
      </div>
    );
  }

  const filteredBenefits =
    activeCategory === 'all'
      ? benefits
      : benefits.filter((b) => b.category?.slug === activeCategory);
  const displayedBenefits = limit ? filteredBenefits.slice(0, limit) : filteredBenefits;

  return (
    <div className="benefit-grid-container">
      {categories.length > 0 && (
        <div className="benefit-grid-filters" role="group" aria-label="Filtrar por categoría">
          <button
            type="button"
            className={`benefit-grid-filter-pill${activeCategory === 'all' ? ' benefit-grid-filter-pill--active' : ''}`}
            onClick={() => setActiveCategory('all')}
          >
            Todos
          </button>
          {categories.map((category) => (
            <button
              key={category.slug}
              type="button"
              className={`benefit-grid-filter-pill${activeCategory === category.slug ? ' benefit-grid-filter-pill--active' : ''}`}
              onClick={() => setActiveCategory(category.slug)}
            >
              {category.name}
            </button>
          ))}
        </div>
      )}
      <div className="benefit-grid">
        {displayedBenefits.map((benefit, index) => (
          <BenefitCard key={benefit.slug || index} benefit={benefit} />
        ))}
      </div>
    </div>
  );
};

export default BenefitGrid;
